<section>
    <div class="py-10 px-4 md:px-8 flex flex-col gap-4 border-b border-border-secondary">
        <h1 class="typography-title-xl textPrimary m-0">{{'cacademy.title' | translate}}</h1>
        <p class="typography-body-l-medium textSecondary-color m-0">{{'cacademy.description' | translate}}</p>
    </div>
    <div class="py-6 px-4 md:px-8 mb-2">
        <h2 class="typography-title-l textPrimary mb-4 mt-0">{{'cacademy.your_formations' | translate}}</h2>
        <div class="flex flex-col gap-4">
            <app-tabs [tabs]="tabs" [activeTab]="activeTab" [textWrap]=false (tabChanged)="onTabChange($event)"></app-tabs>
            <ng-container *ngIf="currentPageFormations && currentPageFormations.length > 0">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 lg:block lg:p-8 lg:bg-white">
                    <div *ngFor="let formation of currentPageFormations" class="lg:py-6 lg:border-b border-border-disabled lg:first:pt-0 lg:last:pb-0 lg:last:border-b-0">
                        <app-c-academy-card
                            [fullWidth]="true"
                            [formation]="formation"
                            (onUpdate)="onFormationUpdate()"
                        ></app-c-academy-card>
                    </div>
                </div>
                <app-pagination [currentPage]="yourFormationsCurrentPage" [totalPages]="yourFormationsTotalPages" (onPageChange)="onYourFormationsPageChange($event)"></app-pagination>
            </ng-container>
            <ng-container *ngIf="currentPageFormations && currentPageFormations.length === 0">
                <div class="bg-white flex h-[200px] justify-center items-center">
                    <span class="typography-title-s">{{'cacademy.no_formations_in_this_state' | translate}}</span>
                </div>
            </ng-container>
        </div>
    </div>
    <div *ngIf="availableFormations && availableFormations.length > 0" class="py-6 px-4 md:px-8">
        <app-c-academy-list
            [formations]="availableFormations"
            [shouldShowFilters]="true"
            [title]="'cacademy.available_formations' | translate"
            (onUpdate)="onFormationUpdate()"
        ></app-c-academy-list>
    </div>
</section>